let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page045_game10/img/bcg2.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 279,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '3',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Kliknij w strzałkę rozwijanej listy rozmiaru czcionki.',
      },
      audio: {
        src: 'games/page045_game10/audio/z22s45-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 615,
        y: 246,
      },
    },
    {
      id: '4',
      // direction: 'left',
      textObj: {
        text: 'Ustaw rozmiar czcionki na 20.',
      },
      audio: {
        src: 'games/page045_game10/audio/z22s45-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 605,
        y: 517,
      },
    },
    {
      id: '5',
      // direction: 'left',
      textObj: {
        text: 'Wciskaj klawisze <br />wybra­nych liter.',
      },
      audio: {
        src: 'games/page045_game10/audio/z22s45-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1004,
        y: 836,
      },
    },
  ],
};
export default elements;
